import { accountApi } from './api/accountApi';
import { authApi } from './api/authApi';
import { productApi } from './api/productApi';
import { staticApi } from './api/staticApi';
import { userApi } from './api/userApi';
import { breadcrumbApi } from './api/breadcrumbApi';
import { reportApi } from './api/reportApi';
import { clearAccount } from './slices/accountSlice';
import { clearAuthentication, updateForbiddenAction } from './slices/authSlice';
import { clearAllProduct } from './slices/productSlice';
import { clearStaticData } from './slices/staticSlice';
import { clearUser } from './slices/userSlice';
import { clearReportSlice } from './slices/reportSlice';
import { resetLoadingState, showLoadingScreen } from './slices/loadingSlice';
import { addQuery, removeQuery } from './slices/loadingSlice';
import { resetConfigSetting } from './slices/configSlice';
import {
  clearPopupState,
  clientSideError,
  closePopup,
  internalServerError,
  jwtExpiryTimeout,
  openPopup,
  setCallbackFn,
} from './slices/popupSlice';
import { clearBreadcrumb } from './slices/breadcrumbSlice';

export const clear = () => (dispatch, getState) => {
  dispatch(clearAuthentication());
  dispatch(clearAccount());
  dispatch(clearStaticData());
  dispatch(clearAllProduct());
  dispatch(clearUser());
  dispatch(showLoadingScreen(false));
  dispatch(resetConfigSetting());
  dispatch(clearPopupState());
  dispatch(closePopup());
  dispatch(clearBreadcrumb());
  dispatch(clearReportSlice());
  dispatch(accountApi.util.resetApiState());
  dispatch(authApi.util.resetApiState());
  dispatch(staticApi.util.resetApiState());
  dispatch(userApi.util.resetApiState());
  dispatch(productApi.util.resetApiState());
  dispatch(breadcrumbApi.util.resetApiState());
  dispatch(reportApi.util.resetApiState());
};

export async function runRtkQuery(payload, dispatch, queryFulfilled, queryTag) {
  const queryName = queryTag + Date.now();
  // console.log('processing the rtk query [' + queryName + '] now -<>-');
  dispatch(addQuery(queryName));
  let result;
  try {
    result = await queryFulfilled;
  } catch (error) {
    console.log('error happened and caught', error.error.data);
    // const errorDataCode = error.error.data.code;
    const errorDataCode = error.error.data.error.code;
    //TODO: all pages should handle error 400 differently so there's no generic popup, make ticket later on
    if (errorDataCode > 400) {
      await dispatchErrorFunctions(dispatch, errorDataCode);
    }
    result = { error: error };
  } finally {
    await dispatch(removeQuery(queryName));
    return result;
  }
}

const dispatchErrorFunctions = async (dispatch, errorCode) => {
  if (errorCode === 403) {
    dispatch(resetLoadingState());
    dispatch(updateForbiddenAction(true));
    //specific case for jwt expiry
  } else if (errorCode === 401) {
    dispatch(setCallbackFn(clear));
    dispatch(jwtExpiryTimeout());
    dispatch(openPopup());
  } else if (errorCode < 500) {
    dispatch(clientSideError());
    dispatch(setCallbackFn(closePopup));
    dispatch(openPopup());
  } else {
    dispatch(internalServerError());
    dispatch(setCallbackFn(closePopup));
    dispatch(openPopup());
  }
};

export const convertHoursToDays = (hours) => {
  return Math.floor(hours / 24);
};
